import React from "react";
import { twMerge } from "tailwind-merge";

type IDataDisplay = {
  title?: string;
  detail: string | React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
};

const DataDisplay: React.FC<IDataDisplay> = ({
  title,
  detail,
  icon,
  className,
}) => {
  return (
    <div className={twMerge("flex flex-col", className)}>
      <div className="text-gray-700 font-semibold capitalize">
        {title && <span>{title}:</span>}
      </div>
      <span className="flex items-center text-gray-900">
        {icon && <span className="mr-2">{icon}</span>}
        {detail}
      </span>
    </div>
  );
};

export default DataDisplay;
